module.exports = __webpack_public_path__ + "static/media/destaque-linhas-retok.4e474718.jpg";